import { Button, Flex, H5, Modal, P } from "orcs-design-system";
import type { Dashboard } from "./types";

type DeleteDashboardModalProps = {
  dashboard: Dashboard;
  isDeleting: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

const DeleteDashboardModal = ({
  dashboard,
  isDeleting,
  onConfirm,
  onClose,
}: DeleteDashboardModalProps) => (
  <Modal
    visible
    onClose={onClose}
    width={["90vw", "90vw", "60vw", "40vw"]}
    headerContent={<H5 fontWeight="bold">Delete dashboard</H5>}
    footerContent={
      <Flex gap="s">
        <Button
          variant="danger"
          onClick={onConfirm}
          disabled={isDeleting}
          isLoading={isDeleting}
          data-testid="ai-dashboard-delete-confirm"
          px="l"
        >
          Delete
        </Button>
        <Button variant="ghost" onClick={onClose} disabled={isDeleting}>
          Cancel
        </Button>
      </Flex>
    }
  >
    <P my="r">
      {`Remove "${dashboard.title}" from your dashboards? You won't be able to open it again.`}
    </P>
  </Modal>
);

export default DeleteDashboardModal;
